import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { CartolaProveedorComponent } from './cartola-proveedores/cartola-proveedores.component';
import { ConsultarPagosProveedoresComponent } from './consultar-pagos-proveedores/consultar-pagos-proveedores.component';
import { DocsPorPagarProveedoresComponent } from './docs-por-pagar-proveedores/docs-por-pagar-proveedores.component';
import { ConsultarPagosProveedorModalViewDetailsComponent } from "./consultar-pagos-proveedores/modal-view-details/modal-view-details.component";
import { CcProveedorPagosComponent } from './cc-proveedor-pagos/cc-proveedor-pagos.component';
import { CcProveedorPagosCabeceraComponent } from './cc-proveedor-pagos/cc-proveedor-pagos-cabecera/cc-proveedor-pagos-cabecera/cc-proveedor-pagos-cabecera.component';
import { CcProveedorPagosListasComponent } from './cc-proveedor-pagos/cc-proveedor-pagos-listas/cc-proveedor-pagos-listas/cc-proveedor-pagos-listas.component';

@NgModule({
  declarations: [
    CartolaProveedorComponent,
    ConsultarPagosProveedoresComponent,
    DocsPorPagarProveedoresComponent,
    ConsultarPagosProveedorModalViewDetailsComponent,
    CcProveedorPagosComponent,
    CcProveedorPagosCabeceraComponent,
    CcProveedorPagosListasComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports: [
    CartolaProveedorComponent,
    ConsultarPagosProveedoresComponent,
    DocsPorPagarProveedoresComponent,
    CcProveedorPagosComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class CtaCteProveedoresModule { }
